import React, {
  useState,
  useEffect,
  Fragment,
  useLayoutEffect,
  useCallback,
  useRef,
  useMemo,
  createRef,
  useContext,
} from "react";
import "./styles.css";
import { useHistory } from "react-router-dom";
import { useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useRazorPay } from "hooks/payment/useRazorPay";
import { useEventLogger } from "hooks/firebase/useEventLogger";
import { usePlaceOrder } from "hooks/usePlaceOrder";
import { ReactComponent as FindIcon } from "common/assets/svg/find.svg";
import { ReactComponent as CloseIcon } from "common/assets/svg/closed.svg";
import { usePaymentProviders } from "hooks/payment/usePaymentProvider";
import { RootState } from "common/rootReducer";
import Otp from "pages/authPages/otp";
import LoginPromt from "components/prompts/loginPromt";
import GuestPopup from "components/prompts/guestPopup";
import throttle from "lodash.throttle";
import OfferPrompt from "components/prompts/desktopOfferPrompt";
import PriceText from "components/priceText";
import { ReactComponent as ArrowIcon } from "common/assets/svg/leftArrow.svg";
import { ReactComponent as Coupon } from "common/assets/svg/coupon1.svg";
import { ReactComponent as CancelIcon } from "common/assets/svg/cancel.svg";
import DropDown from "components/desktopDropdown";
import {
  clearCheckInState,
  showFloatingReservation,
} from "common/features/checkIn/checkInActions";
import ConfirmationPrompt from "components/prompts/confirmationPrompt";
import {
  RESTAURANT_CAMPAIGN_VIEW_EVENT,
  RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS,
} from "firebase/analytics/events";
import {
  getRestaurantDetails,
  getRestaurantMenuDetails,
  getRestaurantMenuDetailsbyDate,
} from "common/features/restaurant/restaurantAction";
import {
  clearCutomizationItem,
  removeCartTip,
  setEventOrder,
  startEmptyCart,
} from "common/features/cart/cartActions";
import RestaurantHome from "pages/restaurantHome";
import { CartItem } from "common/features/cart/cartModels";
import CartItemCard from "components/desktopCartItems";
import { Category } from "common/utils/menu-helper-utils";
import AddTip from "components/InputComponents/addTip";
import AddTipNew from "components/InputComponents/addTipNew";
import { getPlaceOrderDesktopURL } from "common/utils/route-util";
import { AuthContext } from "common/services/auth-service";
import {
  WorkingHours,
  RestaurantMenuItem,
} from "common/features/restaurant/restaurantModels";
import { getToday } from "common/utils/date-time-helper-utils";
import { ReactComponent as DownArrow } from "common/assets/svg/downArrow.svg";
import {
  savePlaceOrderDetails,
  setCurrentOrderType,
  startEmptyCartOrder,
} from "common/features/order/orderActions";
import { GUEST_USER_NAME, USER_NAME } from "common/constants";
import {
  clearSelectedOffer,
  requestgetOffers,
} from "common/features/offers/offerActions";
import { offerRequestBody } from "common/features/offers/offferModels";
import DesktopFooter from "components/desktopFooter";
import { ReactComponent as HeartFilled } from "common/assets/svg/heartFilled.svg";
import { ReactComponent as RightArrowFilled } from "common/assets/svg/rightArrowFilled.svg";
import { ReactComponent as Logout } from "common/assets/svg/logout.svg";
import { signOut } from "common/features/auth/AuthActions";
import { clearUserData } from "common/features/user/userActions";
import { clearPlaceOrder } from "common/features/cart/cartActions";
import { clearLatestOrders } from "common/features/order/orderActions";
import SignupPopup from "components/prompts/signupPopup";
import { ReactComponent as Info } from "common/assets/svg/infoBlue.svg";
import CustomisationPrompt from "components/prompts/desktopCustomisation";

import backgroundBannerImage from "common/assets/svg/MHB2.svg";
import {
  getTotalByCode,
  getTotalByTitle,
  manageItemTotalsHelper,
} from "helper/orderToatals.helper";
import { useOnlinePlaceOrder } from "hooks/useOnlinePlaceOrder";
import ConfirmationPopup from "components/ConfirmationPopup";
import AuthDesktop from "pages/authPages/AuthDesktop";
import CustomizeCartPrevMobile from "components/prompts/cartCustomisationPrevMobile";
import CustomizeCart from "components/prompts/cartCustomisation";

import AmexCard from "common/assets/images/amexpng.png";
import { ReactComponent as MasterCard } from "../../common/assets/svg/Master-card.svg";
import Visa from "common/assets/images/visa.png";
import { ReactComponent as Discover } from "../../common/assets/svg/Discover-card.svg";
import EventDatePopup from "components/EventDatePopup";
import moment from "moment";
import { useIsEventOrders } from "common/features/selectors";
import Tipimg1 from 'common/assets/images/tipimg1.png'
import Tipimg2 from 'common/assets/images/tipimg2.png'
import Tipimg3 from 'common/assets/images/tipimg3.png'
import Tipimg4 from 'common/assets/images/tipimg4.png'
import Tipimg5 from 'common/assets/images/tipimg5.png'

export interface RestaurantFeatures {
  Pickup: boolean;
  Dining: boolean;
  "Car/Bike parking": boolean;
  Alcohol: boolean;
  Delivery: boolean;
}

interface Timing {
  mealPeriod: String;
  availableDays: String;
  timings: string;
}

interface WorkingDay {
  [workingHours: string]: WorkingHours[];
}

export interface guestCart {
  restaurantSlug: string;
  isPendingCart: boolean;
}

export interface MenuRouteState {
  loadMenuRequired?: boolean;
  showSearch?: boolean;
  prevPath?: string;
  backFromPlaceOrder?: boolean;
}

function MerchantInfoDesktop() {
  window.history.replaceState({}, document.title);
  const searchRef: any = createRef();
  const location = useLocation<any>();
  const menuLocationState = useLocation<MenuRouteState>().state;
  const routerPayloads = useSelector(
    (state: RootState) => state.navigation.routerPayloads
  );
  const rPayload = useParams<any>();
  let {
    merchantType,
    merchantSlug,
    campaignId,
    menuType,
    orderId,
    tableId,
    eventDate,
  } = routerPayloads ? routerPayloads : rPayload;

  var video = document.getElementById("merchantVideo");
  var merchantVideoControl = document.getElementById("merchantVideoControl");
  const [isSticky, setSticky] = useState(false);
  const [offerPickerOpen, setOfferPickerOpen] = useState(false);
  const [isTipModalVisible, setIsTipModalVisible] = useState<boolean>(false);
  const [isEventDatePickerVisible, setIsEventDatePickerVisible] =
    useState<boolean>(false);

  const [showExtraCharges, setShowExtraCharges] = useState(false);
  const [showBillDetails, setShowBillDetails] = useState<boolean>(false);
  const [dishes, setDishes] = useState<RestaurantMenuItem[]>([]);
  const [filterDropDown, setFilterDropDown] = useState(true);
  const [logOutbtn, setLogOutBtn] = useState(false);
  const AppAuth = useContext(AuthContext);
  const [userAuth, setUserAuth] = useState<any>("guest");
  const [acmeConsent, setACMEConsent] = useState(true);
  const [tipDialogOpenned, setTipDialogOpenned] = useState(false);

  const userId = localStorage.getItem("USER_ID");
  const isMobile = window.innerWidth <= 500;
  const [payViaRazorPay, retryPaymentViaRazorPay, paymentTransferLoading] =
    useRazorPay(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [updatedMenu, setUpdatedMenu] = useState("");

  const isEventOrders = useIsEventOrders();

  
  const images: any = [
      {
        img: Tipimg1
      },
      {
        img: Tipimg2
      },
      {
        img: Tipimg3
      },
      {
        img: Tipimg4
      },
      {
        img: Tipimg5
      }
    ];

  useEffect(() => {
    dispatch(
      setEventOrder(
        isEventDate ? isEventDate : false,
        eventDate ? eventDate : ""
      )
    );
  }, [eventDate]);

  // const [
  //   makeOrder,
  //   totalItemsubTotal,
  //   totalOrderPrice,
  //   totalTaxAndCharges,
  //   totalItemTaxAmount,
  //   tipAmount,
  //   packagingCharge,
  //   discountAmount,
  //   serviceCharge,
  //   updateOrder,
  //   walletAmount,
  //   RedeemedWalletAmt,
  //   convenienceFee,
  // ] = usePlaceOrder();

  const [
    makeOrder,
    updateOrder,
    totalOrderPrice,
    totalItemsubTotal,
    orderTotals,
    tipAmount,
    discountAmount,
    deliveryFee,
  ] = useOnlinePlaceOrder();
  const isAppliedTip = useSelector(
    (state: RootState) => state.cart.isAppliedTip
  );
  const isEventDate = useSelector((state: RootState) => state.cart.isEventDate);

  const [paymentProvider, PaymentModal, isPaymentModalOpen] =
    usePaymentProviders(totalOrderPrice);
  const [paymentMethodDropdownOpen, setPaymentMethodDropdownOpen] =
    useState(false);

  useEffect(() => {
    let component = document && document.getElementById("innerContainer");
    if (component !== null) {
      component.classList.add("desktop");
    }

    return () => {
      if (component !== null) {
        component.classList.remove("desktop");
      }
    };
  }, []);

  const cardImages = (card: string) => {
    switch (card) {
      case "AMEX":
        return (
          <span className="paymentCardLogo">
            <img src={AmexCard} />
          </span>
        );
      case "Master":
        return (
          <span className="paymentCardLogo">
            <MasterCard />
          </span>
        );
      case "Discover":
        return (
          <span className="paymentCardLogo">
            <Discover />
          </span>
        );
      case "Visa":
        return (
          <span className="paymentCardLogo">
            <img style={{ marginTop: "4px" }} src={Visa} />
          </span>
        );
      default:
        return false;
    }
  };

  useEffect(() => {
    // console.log({ AppAuth });

    setUserAuth(AppAuth?.userState?.toString());
  }, [AppAuth]);

  const cartItems: Array<CartItem> = useSelector(
    (state: RootState) => state.cart.cart.items
  );

  const [isFavourite, setIsFavourite] = useState(0);
  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue((value) => value + 1);
  }
  const menuCategories: Array<string> = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuCategories
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const [logEvent] = useEventLogger();
  const routeState = useLocation<any>().state;

  const [categories, setCategories] = useState<Category>({});

  // const [SelectedOption, setSelectedOption] = useState("AboutUs");
  const [selectedMenuType, setSelectedMenuType] = useState(
    menuType ? menuType : ""
  );
  const [selectedMenuTypeGroup, setSelectedMenuTypeGroup] = useState("");

  const UserId = localStorage.getItem("USER_ID");
  const userName: any =
    localStorage.getItem(USER_NAME) || localStorage.getItem(GUEST_USER_NAME);

  const [tel, setTel] = useState("");
  const [searchText, setSearchText] = useState("");
  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );
  const restaurantDetailsLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantDetailLoading
  );
  const restaurantFailMessage = useSelector(
    (state: RootState) => state.restaurant.restaurantDetailFailMessage
  );
  const merchantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );

  const isGuestMobileVerified = useSelector(
    (state: RootState) => state.cart.isGuestMobileVerified
  );

  const selectedOffer = useSelector(
    (state: RootState) => state.offer.selectedOffer
  );

  const availWalletAmount = useSelector(
    (state: RootState) => state.offer.availWalletAmount
  );

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.country
  );

  const deliveryAddress = useSelector(
    (state: RootState) => state.cart.deliveryAddress
  );

  const currentRestaurantDetailLoading = useSelector(
    (state: RootState) => state.restaurant.currentLocationRestaurantsLoading
  );

  const placeOrderLoading = useSelector(
    (state: RootState) => state.cart.placeOrderLoading
  );
  const tipType = useSelector((state: RootState) => state.cart.tipType);

  const cartDetails = useSelector((state: RootState) => state.cart);
  const cartMenuType = useSelector(
    (state: RootState) => state.cart.cartMenuType
  );
  const cartRestaurantDetails = useSelector(
    (state: RootState) => state.cart.cartRestaurantDetails
  );
  const restaurantMenuDetails: Array<RestaurantMenuItem> = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetails
  );
  const currentMenuType = useSelector(
    (state: RootState) => state.restaurant.currentMenuType
  );

  
  const classData = restaurantDetails?.paymentProvider?.classData
    ? JSON.parse(restaurantDetails.paymentProvider?.classData)
    : null;
  const isPOD = classData?.paymentOptions.includes("PAY_ON_DELIVERY") || false;
  const isPAS = classData?.paymentOptions.includes("PAY_AT_STORE") || false;

  const sortByType = (a: any, b: any) => {
    if (a.typeGroup === "P") return -1;
    if (b.typeGroup === "P") return 1;
    return 0;
  };

  const orderTypes = useMemo(() => {
    const tempOrderTypes = merchantOrderTypes ? [...merchantOrderTypes] : [];
    const activeOrderTypes = tempOrderTypes
      .sort(sortByType)
      .filter(
        (orderType) =>
          orderType.isEnabled == 1 &&
          orderType.typeGroup != "I" &&
          orderType.typeGroup != "D"
      )
      .map((orderType) => orderType.typeName);
    return activeOrderTypes.length > 0 ? activeOrderTypes : ["Menu"];
  }, [merchantOrderTypes, restaurantDetails]);

  useEffect(() => {
    if (!currentRestaurantDetailLoading) {
      if (currentMenuType && orderTypes.includes(currentMenuType)) {
        setSelectedMenuType(currentMenuType);
      } else {
        dispatch(clearPlaceOrder());
        menuType
          ? setSelectedMenuType(menuType)
          : orderTypes.length > 0
          ? setSelectedMenuType(orderTypes[0])
          : setSelectedMenuType("Menu");
      }
    }
  }, [restaurantDetails, currentRestaurantDetailLoading, orderTypes, menuType]);

  const orderApiTotals = useSelector((state: RootState) => state.order.totals);

  const orderItems = useSelector(
    (state: RootState) => state.cart.cart.items
    //state.order.orderItems
  );
  
  // useEffect(async() => {
  //   if(cartItems?.length > 0 && restaurantDetails?.id){
  //     const payload = {
  //       discount: discountAmount,
  //       discountType:"FLATFEE",
  //       orderItems: cartItems,
  //       orderTypeId: restaurantOrderTypeId,
  //       locationId: restaurantDetails.id ,
  //       tip:tipAmount,
  //       walletBalance:RedeemedWalletAmt
  //     }
  //     const data = await manageItemTotalsHelper(payload)

  //     data && dispatch(
  //       savePlaceOrderDetails({
  //         discountValue:  Number(getTotalByCode(data?.orderTotals, '6')) || 0,
  //         discountType:"FLATFEE",
  //         totals:data?.orderTotals,
  //         orderTotal:data?.orderTotal,
  //         orderItems:data?.orderItems,
  //         tip:Number(getTotalByCode(data?.orderTotals, '3')) || 0,
  //         RedeemedWalletAmount:RedeemedWalletAmt
  //       }),
  //     );
  //   }
  // }, [restaurantDetails,discountAmount,tipAmount])

  const cutOffTimeExceeds = React.useCallback(
    (orderType: string) => {
      const item = restaurantDetails?.orderTypes?.filter(
        (item) => item.typeName === orderType && item.isEnabled == 1
      );
      const typeGroup = item && item[0]?.typeGroup;
      return typeGroup == "P"
        ? restaurantDetails.pickupCutOffTimeExceeds == 0
        : typeGroup == "S"
        ? restaurantDetails.deliveryCutOffTimeExceeds == 0
        : false;
    },
    [restaurantDetails]
  );

  useEffect(() => {
    if (!currentRestaurantDetailLoading) {
      if (cutOffTimeExceeds(menuType) || restaurantDetails?.open === 0) {
        dispatch(clearPlaceOrder());
      }
    }
  }, [restaurantDetails, currentRestaurantDetailLoading, menuType]);

  const [timeExpanded, setTimeExpanded] = useState(false);

  const toggleExpanded = () => {
    setTimeExpanded(!timeExpanded);
  };

  const resCost = useMemo((): string => {
    return (
      (restaurantDetails &&
        restaurantDetails.cost &&
        restaurantDetails.cost.split("-")[0]) ||
      ""
    );
  }, [restaurantDetails.cost]);

  const resPerson = useMemo((): string => {
    return (
      (restaurantDetails &&
        restaurantDetails.cost &&
        restaurantDetails.cost.split("-")[1]) ||
      ""
    );
  }, [restaurantDetails.cost]);

  const isDeliveryOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        return (
          orderType.typeName == selectedMenuType &&
          orderType.typeGroup == "S" &&
          orderType.isEnabled == 1
        );
      }) || false
    );
  }, [restaurantDetails, selectedMenuType]);

  const isPickupOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        return (
          orderType.typeName == selectedMenuType &&
          orderType.typeGroup == "P" &&
          orderType.isEnabled == 1
        );
      }) || false
    );
  }, [restaurantDetails, selectedMenuType]);

  const forceUpdate = useForceUpdate();
  // useEffect(() => {
  //   console.log("390");
  //   forceUpdate();
  // }, [searchText]);

  useLayoutEffect(() => {
    // dispatch(getRestaurantDetails(merchantSlug, merchantType));
    dispatch(clearCheckInState());
    dispatch(showFloatingReservation());

    campaignId &&
      setTimeout(() => {
        logEvent(RESTAURANT_CAMPAIGN_VIEW_EVENT, {
          campaignId: campaignId,
          merchant: merchantSlug,
        } as RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS);
      }, 3000);
  }, []);

  useEffect(() => {
    if (restaurantDetails?.id) {
      dispatch(
        requestgetOffers({
          locationId: restaurantDetails?.id,
          couponId: "",
          customerId: userId,
          orderType: cartMenuType,
          visibleTo: "C",
        } as offerRequestBody)
      );
    }
  }, [restaurantDetails]);

  useEffect(() => {
    setTel("tel:" + restaurantDetails.phoneNumber);
    // console.log(restaurantDetails.media[0]);
  }, [restaurantDetails]);

  // useEffect(() => {
  //   if (!restaurantDetailsLoading && restaurantFailMessage != "") {
  //     history.replace("/notFound");
  //   }
  // }, [restaurantFailMessage]);

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails && restaurantDetails.media.length > 0) {
        const logoMedia =
          restaurantDetails &&
          restaurantDetails.media.filter(
            (media) => media.entityType == type
          )[0];

        return (
          logoMedia.mimeType &&
          process.env.REACT_APP_IMAGE_URL +
            logoMedia.mimeType.split("/")[0] +
            "/" +
            logoMedia.id +
            "." +
            logoMedia.mimeType.split("/")[1]
        );
      } else {
        return "";
      }
    },
    [restaurantDetails, cartRestaurantDetails]
  );

  const orderTypeTabRef = useRef<HTMLDivElement>(null);
  const restaurantListRef = useRef<HTMLDivElement>(null);
  const handleScroll = () => {
    if (restaurantListRef.current != null && orderTypeTabRef.current != null) {
      const tabBoundings = orderTypeTabRef.current.getBoundingClientRect();
      const listBoundings = restaurantListRef?.current?.getBoundingClientRect();

      const isTop = listBoundings.top - tabBoundings.height;
      if (isTop <= 0) {
        setSticky(true);
        restaurantListRef.current.style.marginTop =
          tabBoundings.height.toString() + "px";
      } else {
        setSticky(false);
        restaurantListRef.current.style.marginTop = "0px";
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", () => handleScroll);
    };
  }, []);

  // const getOrderTypes = () => {
  //   let orderTypes: Array<string> = [];
  //   orderTypes =
  //     merchantOrderTypes &&
  //     restaurantDetails.orderTypes &&
  //     restaurantDetails.orderTypes
  //       ? restaurantDetails.orderTypes
  //           .filter(
  //             (orderType) =>
  //               orderType.typeGroup != "I" && orderType.typeGroup != "D"
  //           )
  //           .map((orderType) => orderType.typeName)
  //       : [""];
  //   console.log(orderTypes, "order types");
  //   return orderTypes;
  // };
  useEffect(() => {
    if (!restaurantDetailsLoading) {
      getCategories(selectedMenuType);
    }
  }, [selectedMenuType, restaurantDetailsLoading]);

  useEffect(() => {
    // Start Cart if Not Initialized
    if (orderTypes.length > 0) {
      if (menuLocationState && Object.keys(menuLocationState).length > 0) {
        menuLocationState.loadMenuRequired && getCategories(selectedMenuType);
      }
    }
  }, [restaurantDetails, selectedMenuType, eventDate]);

  useEffect(() => {
    if (menuLocationState?.backFromPlaceOrder === true) {
      setTipDialogOpenned(true);
    }
  }, [menuLocationState]);

  useEffect(() => {
    let workingDays: WorkingDay = {};
    restaurantDetails.workingHours.map((workingHour: any) => {
      if (Object.keys(workingDays).includes(workingHour.weekday)) {
        let hours = workingDays[workingHour.weekday];
        if(workingHour?.isEnabled === '1'){
          workingDays[workingHour.weekday] = [...hours, workingHour];
        }
      } else {
        workingDays[workingHour.weekday] = workingHour?.isEnabled === '1' ? [workingHour] : [];
      }
    });
    setWorkingDays(workingDays);
    setTodayTimings(workingDays[getToday()]);
    // setUniqueDays(Object.keys(workingDays));
  }, [restaurantDetails]);

  const getCategories = (menuType: string) => {
    let orderType = restaurantDetails.orderTypes?.filter(
      (restaurantDetails) => {
        if (restaurantDetails.typeGroup == "D") {
          return restaurantDetails.typeName;
        }
      }
    );
    if (
      restaurantDetails &&
      restaurantDetails.id &&
      selectedMenuType &&
      cartItems?.length === 0
    ) {
      isEventOrders &&
        dispatch(
          getRestaurantMenuDetailsbyDate({
            type:
              selectedMenuType === "Menu"
                ? orderType
                  ? orderType[0]?.typeName
                  : "DineIn"
                : selectedMenuType,
            locationId: restaurantDetails.id,
            customerId: UserId,
            searchText:
              // location.state.keyword && location.state.keyword != null
              //   ? location.state.keyword
              // :
              null,
            visibleTo: "C",
            eventSlug: eventDate,
          })
        );
      !isEventOrders &&
        dispatch(
          getRestaurantMenuDetails({
            type:
              selectedMenuType === "Menu"
                ? orderType
                  ? orderType[0]?.typeName
                  : "DineIn"
                : selectedMenuType,
            locationId: restaurantDetails.id,
            customerId: UserId,
            searchText:
              // location.state.keyword && location.state.keyword != null
              //   ? location.state.keyword
              // :
              null,
            visibleTo: "C",
          })
        );
    }
  };

  const closeOfferPicker = (set: boolean) => {
    if (set) {
      setOfferPickerOpen(false);
    }
  };

  const currentRestaurantMenuType = useSelector(
    (state: RootState) => state.restaurant.currentMenuType
  );

  // console.log({currentRestaurantMenuType});
  
  let minOrderAmount = restaurantDetails.orderTypes?.find(
    (name) => name.typeName === currentRestaurantMenuType
  );

  //todo: optimize 2 api calls // Done
  const onSubmit = async () => {
    if (acmeConsent) {
      if (userAuth === "signedIn" || userAuth === "guestSignedIn") {
        if (isDeliveryOrder) {
          history.push({
            pathname: getPlaceOrderDesktopURL(merchantType, merchantSlug),
            state: { menuType: selectedMenuType },
          });
        } else if (isPickupOrder) {
          if (
            minOrderAmount &&
            totalItemsubTotal >= minOrderAmount?.minOrderAmount &&
            totalOrderPrice > 0
          ) {
            history.push({
              pathname: getPlaceOrderDesktopURL(merchantType, merchantSlug),
              state: { menuType: selectedMenuType },
            });
          }
        }
      } else {
        setloginRequestPopup(true);
      }
    }
  };

  const [cartClearPopup, setcartCearPopup] = useState({
    isOpen: false,
    menuType: "",
  });
  const [user, setUser] = useState({ email: "", password: "" });
  const [signUp, setSignUp] = useState(false);
  const [open, setOpenPrompt] = useState(false);

  const [todayTimings, setTodayTimings] = useState<WorkingHours[]>([]);
  const [workingDays, setWorkingDays] = useState<WorkingDay>({});
  const [showExtraOpeningHours, setShowExtraOpeningHours] = useState(false);
  const [totalDish, setTotalDish] = useState(0);
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const throttledOnSubmit = throttle(onSubmit, 5000);

  const getFormattedTime = (timing: WorkingHours) => {
    return (
      timing.openingTime.split(":")[0] +
      ":" +
      timing.openingTime.split(":")[1] +
      " - " +
      timing.closingTime.split(":")[0] +
      ":" +
      timing.closingTime.split(":")[1]
    );
  };

  const formatTo12Hour = (time: string): string => {
    const [hourStr, minuteStr] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr;
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    if (hour === 0) hour = 12;
    return `${hour}:${minute} ${ampm}`;
  };
  
  const formatTime = (timing: any): string => {
    const opening = formatTo12Hour(timing.openingTime);
    const closing = formatTo12Hour(timing.closingTime);
    return `${opening} - ${closing}`;
  };

  const isHolidayTime = (hoursData: WorkingHours) => {
    if (
      hoursData &&
      hoursData?.openingTime == "00:00:00" &&
      hoursData?.closingTime == "00:00:00"
    ) {
      return false;
    } else {
      return false;
    }
  };

  useEffect(() => {
    // Get Restaurant Details
    if (!isMobile && restaurantDetails.locationSlug !== merchantSlug) {
      dispatch(getRestaurantDetails(merchantSlug));
    }
  }, []);

  const getFromTodayDays = useCallback(() => {
    let todayIndex: number = new Date().getDay();
    let fromTodayIndex = [];
    let fromTodayDays: string[] = [];
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let dayIndex = todayIndex;
    for (let i = 0; i < 7; i++) {
      // Excluding Today Index - 6 days
      if (dayIndex != todayIndex) {
        fromTodayIndex.push(dayIndex);
      }
      dayIndex = (dayIndex + 1) % 7;
    }
    // console.log(fromTodayIndex, todayIndex);

    fromTodayIndex.forEach((index: number) => {
      fromTodayDays.push(days[index]);
    });
    return fromTodayDays;
  }, []);

  const restaurantMenu = useMemo(() => {
    return restaurantMenuDetails;
  }, [restaurantMenuDetails]);

  useEffect(() => {
    if (restaurantMenu && restaurantMenu.length > 0) {
      setDishes([...restaurantMenu]);
    }
  }, [restaurantMenu]);

  useEffect(() => {
    if (cartItems?.length === 0) {
      dispatch(clearSelectedOffer());
    }
  }, [cartItems]);

  const filterdDish = dishes?.filter(
    (item) =>
      searchText?.length > 0 &&
      item?.itemName.toLowerCase().includes(searchText.toLowerCase())
  );

  const displayDish = filterdDish.filter((item) => item?.display);

  const restaurantMenuDetailLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantMenuDetailLoading
  );
  const restaurantDetailLoading = useSelector(
    (state: RootState) => state.restaurant.restaurantDetailLoading
  );

  const dishData = (dishes: any) => {
    setTotalDish(dishes?.length);
  };

  const totalsApiLoading = useSelector(
    (state: RootState) => state.order.totalsApiLoading
  );

  const address = restaurantDetails?.address.split(",");

  const [loginRequestPopup, setloginRequestPopup] = useState(false);

  // const submitPrompt = (answer: boolean) => {
  //   if (answer) {
  //     setSelectedMenuType(cartClearPopup.menuType);
  //     setSearchText("");
  //     dispatch(
  //       startEmptyCart({
  //         menuType: cartClearPopup.menuType,
  //         restaurantSlug: merchantSlug,
  //         clearCartItems: true,
  //         merchantType: merchantType,
  //         cartType: "CART",
  //       })
  //     );
  //     dispatch(startEmptyCartOrder())
  //     dispatch(clearCutomizationItem())
  //   } else {
  //     //setSelectedMenuType(cartClearPopup.menuType);
  //     setSearchText("");
  //   }

  //   setcartCearPopup({ isOpen: false, menuType: "" });
  // };

  const [openCustomisation, setOpenCustomisation] = useState(false);
  const [openCustomisationPreview, setOpenCustomisationPreview] =
    useState(false);

  const [customisationItemId, setCustomisationItemId] = useState("");

  const isServiceable = useMemo(() => {
    if (restaurantDetails) {
      const isDeliverySevicable = restaurantDetails?.orderTypes?.some(
        (type) => {
          return type?.typeGroup == "S" && type?.isEnabled == 0;
        }
      );
      const isPickupSevicable = restaurantDetails?.orderTypes?.some((type) => {
        return type?.typeGroup == "P" && type?.isEnabled == 0;
      });
      return isDeliverySevicable && isPickupSevicable ? true : false;
    } else {
      return false;
    }
  }, [restaurantDetails]);

  const isShowPopup = useSelector((state: RootState) => state.scheduler.isShowPopup);
  const schedulerMessage = useSelector((state: RootState) => state.scheduler.schedulerMessage);
  const formattedMessage = schedulerMessage?.replace(
    /\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|TOMORROW)\b(?![:;])/g, "<strong>$1</strong>"
  ).replace(/\b\d{1,2}:\d{2} [APM]{2}\b/g,"<strong>$&</strong>")
  

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSubmitPopup = (menu: string) => {
    setIsPopupOpen(false);
    setSelectedMenuType(menu);
    setSearchText("");
    dispatch(
      startEmptyCart({
        menuType: cartClearPopup.menuType,
        restaurantSlug: merchantSlug,
        clearCartItems: true,
        merchantType: merchantType,
        cartType: "CART",
      })
    );
    dispatch(startEmptyCartOrder());

    dispatch(clearCutomizationItem());
  };

  return (
    <>
      {loginRequestPopup && (
        <AuthDesktop
          isOpen={loginRequestPopup}
          setIsOpen={setloginRequestPopup}
        />
      )}
      {isPopupOpen && (
        <ConfirmationPopup
          onClose={handleClosePopup}
          onSubmit={handleSubmitPopup}
          updatedMenu={updatedMenu}
        />
      )}

      {AppAuth?.userState !== "guest" && PaymentModal()}
      <OfferPrompt
        isOpen={offerPickerOpen}
        onClose={closeOfferPicker}
        isCopied={false}
      />

      {isEventDatePickerVisible && (
        <EventDatePopup
          eventDate={eventDate}
          onClose={() => setIsEventDatePickerVisible(!isEventDatePickerVisible)}
        />
      )}

      {isTipModalVisible && (
    currentRestaurantMenuType==="Delivery"?

        <AddTipNew
          isVisible={isTipModalVisible}
          setIsVisible={setIsTipModalVisible}
          totalPrice={totalItemsubTotal}
             images={images}
        />: <AddTip
          isVisible={isTipModalVisible}
          setIsVisible={setIsTipModalVisible}
          totalPrice={totalItemsubTotal}
        />
      )}

      {/* <CustomisationPrompt eventDate && 
        isOpen={openCustomisation}
        onClose={() => {
          setCustomisationItemId("");
          setOpenCustomisation(false);
        }}
        itemId={customisationItemId}
        setOpenCustomisation={setOpenCustomisation}
      /> */}

      {openCustomisation && (
        <CustomizeCart
          isOpen={openCustomisation}
          onClose={(isMobileCart: boolean) => {
            setCustomisationItemId("");
            setOpenCustomisation(false);
            setOpenCustomisationPreview(false);
            isMobileCart && window.history.back();
          }}
          custimizeItemId={customisationItemId}
          setOpenCustomisation={setOpenCustomisation}
          isPreview={openCustomisationPreview}
          isMobile={isMobile}
          tableId={""}
          menuType={selectedMenuType}
          cutOffTimeExceeds={cutOffTimeExceeds(selectedMenuType)}
        />
      )}

      <div id="desktop-homePage">
        <Fragment>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              padding: "0 3rem",
              paddingTop: "1rem",
              position: "sticky",
              top: "0",
              left: "0",
              right: "0",
              backgroundColor: "#fff",
              zIndex: "15",
            }}
          >
            <div style={{ marginRight: "2rem", position: "relative" }}>
              {!isEventOrders && (
                <div
                  className={
                    orderTypes.length > 0 ? "menuUnfilledContainer" : ""
                  }
                >
                  {orderTypes.length > 0 &&
                    orderTypes.map((item, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (
                              cartItems.length > 0 &&
                              item != selectedMenuType
                            ) {
                              setUpdatedMenu(item);
                              handleOpenPopup();
                              // setcartCearPopup({ isOpen: true, menuType: item });
                            } else {
                              if (item != selectedMenuType) {
                                setSelectedMenuType(item);
                                setSearchText("");
                                dispatch(
                                  startEmptyCart({
                                    menuType: item,
                                    restaurantSlug: merchantSlug,
                                    clearCartItems: true,
                                    merchantType: merchantType,
                                    cartType: "CART",
                                  })
                                );
                                dispatch(startEmptyCartOrder());
                              }
                            }
                          }}
                          className={
                            selectedMenuType == item
                              ? "menuFilled"
                              : "menuUnfilled"
                          }
                        >
                          {item}
                        </div>
                      );
                    })}
                </div>
              )}

              {isEventOrders && (
                <div
                  className={
                    orderTypes.length > 0 ? "menuUnfilledContainer" : ""
                  }
                >
                  <div className={"menuFilled"}>Pickup</div>
                </div>
              )}

              {/* <DropDown
                value={selectedMenuType}
                type={"form"}
                // setValue={setSelectedMenuType}
                onChange={(e: any) => {
                  if (cartItems.length > 0 && e != selectedMenuType) {
                    setcartCearPopup({ isOpen: true, menuType: e });
                  } else {
                    if(e != selectedMenuType){
                      submitPrompt(e);
                      setSelectedMenuType(e);
                      setSearchText("");
                      dispatch(
                        startEmptyCart({
                          menuType: e,
                          restaurantSlug: merchantSlug,
                          clearCartItems: true,
                          merchantType: merchantType,
                          cartType: "CART",
                        })
                      );
                    }
                  }
                  // getCategories(e);
                }}
                defaultValue={selectedMenuType}
                labelName={"OrderPref"}
                dropDownOptions={orderTypes}
              /> */}

              {/* <select
                className="desktop-dropdown-container"
                value={selectedMenuType}
                onChange={(e: any) => {
                  setSelectedMenuType(e.target.value);
                  setSearchText("");
                  dispatch(
                    startEmptyCart({
                      menuType: e.target.value,
                      restaurantSlug: merchantSlug,
                      clearCartItems: true,
                      merchantType: merchantType,
                      cartType: "CART",
                    })
                  );
                  // getCategories(e);
                }}
                style={{ color: "#fff", fontSize: "1rem", fontWeight: 400 }}
              >
                {orderTypes &&
                  orderTypes.map((data, i) => {
                    return (
                      <option value={data} className="desktop-dropdown-data">
                        {data}
                      </option>
                    );
                  })}
              </select> */}
            </div>
            {address.map((v, i) => {
              if (i === 0) {
                return (
                  <>
                    <span style={{ fontWeight: "500" }}>{v}</span>&nbsp;
                  </>
                );
              } else if (i !== address?.length - 1) {
                return (
                  <>
                    <span>{`${v},`}</span>&nbsp;
                  </>
                );
              } else {
                return <span>{v}</span>;
              }
            })}
            {userName && (
              <>
                <div style={{ marginLeft: "auto", position: "relative" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => setLogOutBtn(!logOutbtn)}
                  >
                    <div className="user-logo">
                      {userName[0]?.toUpperCase()}
                    </div>
                    <div className="userName-profile">{userName}</div>
                  </div>
                  {logOutbtn && (
                    <div
                      className="logoutButton"
                      onClick={() => {
                        dispatch(signOut());
                        dispatch(clearUserData());
                        dispatch(clearPlaceOrder());
                        dispatch(clearLatestOrders());
                        dispatch(startEmptyCartOrder());
                        setloginRequestPopup(true);
                      }}
                    >
                      <div className="logout-btn">
                        <Logout />
                        <span className="logoutText">Log Out</span>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="merchant-banner-container">
            <div
              className="merchant-banner-details"
              //----- background banner---------
              style={{
                backgroundImage: `url(${backgroundBannerImage})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                className="row"
                style={{ margin: "0 3rem", padding: "20px 0" }}
              >
                <div className="col-12">
                  <div className="row">
                    <div className="col-2">
                      <img src={getImageURL("LOGO")} alt="logo" />
                    </div>
                    <div className="col-1">
                      <div className="row">&nbsp;</div>
                    </div>

                    <div className="col-10">
                      <div className="row">
                        <div className="col-8 restaurant-about">
                          <span id="Restaurant">
                            {restaurantDetails.branchName.split(",")[0]}
                          </span>
                          {/* <div className="about-us-btn">
                            <Info />
                            <span className="info-txt">Info</span>
                          </div> */}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <span className="addressText">
                            {restaurantDetails.branchName.split(",")[1]}
                          </span>
                        </div>
                        <div className="col-6"></div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          maxWidth: "600px",
                          minWidth: "66.6%",
                        }}
                      >
                        <div className="firstContainer">
                          <HeartFilled
                            style={{ height: "15px", marginRight: "5px" }}
                          />
                          <span> {restaurantDetails.rating} Foodies</span>
                        </div>
                        {restaurantDetails.cost != null && (
                          <div className="thirdContainer">
                            <div
                              style={{
                                width: "100%",
                                fontSize: "12px",
                                lineHeight: "18px",
                              }}
                            >
                              <span
                                style={{
                                  padding: 0,
                                  marginRight: "5px",
                                }}
                              >
                                {restaurantDetails &&
                                restaurantDetails.country == "US" ? (
                                  <Fragment>&#36;{`  ${resCost}`}</Fragment>
                                ) :restaurantDetails.country =="IN" ?(
                                  <Fragment>
                                    {" "}
                                    <span
                                      style={{ fontFamily: "Rupee Foradian" }}
                                    >
                                      ₹{`  ${resCost}`}
                                    </span>
                                  </Fragment>
                                ):''}
                              </span>
                              <br />
                              <span className="addressText addressText-cost">
                                Cost for {resPerson}
                              </span>
                            </div>
                          </div>
                        )}
                        <div
                          className={
                            restaurantDetails?.cards?.length > 0
                              ? "thirdContainer-time-b"
                              : "thirdContainer-time"
                          }
                          style={{
                            background: restaurantDetails.open
                              ? "#e0fbd4"
                              : "#FFA5A5",
                          }}
                        >
                          <div className="third-container-title">
                            {restaurantDetails.open ? (
                              <span className="opened-txt">Opens</span>
                            ) : (
                              <span className="closed-txt">Closed</span>
                            )}
                            <br />
                            <span
                              className="addressText addressText-days"
                              style={{ marginBottom: "0", color: "#000" }}
                            >
                              For{" "}
                              {selectedMenuType
                                ? selectedMenuType
                                : orderTypes[0]}
                            </span>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexDirection: "row",
                                marginTop: 5,
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  width: "70px",
                                  textAlign: "left",
                                  fontSize: "10px",
                                  color: "#000",
                                }}
                              >
                                {" "}
                                Timings{" "}
                              </span>
                              <DownArrow
                                style={{
                                  height: "6px",
                                  marginLeft: "12px",
                                  cursor: "pointer",
                                  right: "10px",
                                  top: "6px",
                                }}
                                onClick={() =>
                                  setShowExtraOpeningHours(
                                    !showExtraOpeningHours
                                  )
                                }
                                className={
                                  showExtraOpeningHours
                                    ? "rotateUp"
                                    : "rotateRight"
                                }
                              />
                            </div>
                            <div
                              id="About-us-container-timings-details about-us-card"
                              style={{
                                position: "absolute",
                                left: 0,
                                right: 0,
                                width: "100%",
                                backgroundColor: restaurantDetails.open
                                  ? "#e0fbd4"
                                  : "#FFA5A5",
                                boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.25)",
                                padding: "0 0px 5px 0px",
                                zIndex: "14",
                                borderRadius: "5px",
                                display:'flex',
                                justifyContent:'center'
                              }}
                            >
                              {showExtraOpeningHours && (
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      width: "100%",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      {restaurantDetails?.workingHours[0]
                                        ?.weekday == "All" ? (
                                        <div
                                          className="addressText-days"
                                          style={{
                                            flexDirection: "row",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "baseline",
                                            padding: "0 12px",
                                          }}
                                        >
                                          <span>
                                            {restaurantDetails?.workingHours[0]
                                              ?.weekday + " Days"}
                                          </span>
                                          &nbsp;&nbsp;&nbsp;&nbsp;
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "flex-start",
                                            }}
                                          >
                                            {restaurantDetails?.workingHours.map(
                                              (workingHour, index) => {
                                                return (
                                                  <span
                                                    key={index}
                                                    style={{ marginTop: 5 }}
                                                  >
                                                    {formatTime(
                                                      workingHour
                                                    )}{" "}
                                                    {index <
                                                    restaurantDetails
                                                      ?.workingHours?.length -
                                                      1 ? (
                                                      <Fragment></Fragment>
                                                    ) : null}
                                                  </span>
                                                );
                                              }
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            // justifyContent: "space-between",
                                            width: "100%",
                                          }}
                                        >
                                          {todayTimings?.length > 0 ? (
                                            <Fragment>
                                              <div
                                                className="openHoursContainer"
                                                style={{ display: "flex" }}
                                              >
                                                {/* <p>{getTodayTimings()?.weekday}</p> */}
                                                <span
                                                  style={{
                                                    width: "70px",
                                                    textAlign: "left",
                                                    fontSize: "10px",
                                                    color: "#000",
                                                  }}
                                                >
                                                  Today
                                                </span>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent:
                                                      "flex-start",
                                                  }}
                                                >
                                                  {isHolidayTime(
                                                    todayTimings[0]
                                                  ) ? (
                                                    <p
                                                      style={{
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      CLOSED
                                                    </p>
                                                  ) : (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                      }}
                                                    >
                                                      {todayTimings?.map(
                                                        (
                                                          todayTiming: WorkingHours,
                                                          index: number
                                                        ) => {
                                                          return (
                                                            <span
                                                              key={index}
                                                              style={{
                                                                fontSize:
                                                                  "10px",
                                                                color: "#000",
                                                              }}
                                                            >
                                                              {formatTime(
                                                                todayTiming
                                                              )}
                                                              {index <
                                                              todayTimings?.length -
                                                                1 ? (
                                                                <Fragment>
                                                                  &nbsp;,&nbsp;
                                                                </Fragment>
                                                              ) : null}
                                                            </span>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </Fragment>
                                          ) : workingDays[getToday()] ? 
                                            <>
                                              <span
                                                  style={{
                                                    width: "70px",
                                                    textAlign: "left",
                                                    fontSize: "10px",
                                                    color: "#000",
                                                  }}
                                                >
                                                  Today
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "flex-start",
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  CLOSED
                                                </p>
                                              </div>
                                            </> : null}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {getFromTodayDays().map(
                                    (day: string, index) => (
                                      <Fragment>
                                        {Object.keys(workingDays).includes(
                                          day
                                        ) ? (
                                          <Fragment>
                                            <div
                                              className="openHoursContainer"
                                              style={{ display: "flex" }}
                                              key={index}
                                            >
                                              <span
                                                style={{
                                                  width: "70px",
                                                  textAlign: "left",
                                                  fontSize: "10px",
                                                  color: "#000",
                                                }}
                                              >
                                                {day}
                                              </span>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                {!isHolidayTime(workingDays[day]?.[0]) ? (
                                                  workingDays[day]?.length > 0 ? (
                                                    workingDays[day].map((workingDayTiming, idx) => (
                                                      <span
                                                        key={idx}
                                                        style={{ fontSize: "10px", color: "#000" }}
                                                      >
                                                        {formatTime(workingDayTiming)}
                                                        {idx < workingDays[day].length - 1 ? '\u00A0' : ''}
                                                      </span>
                                                    ))
                                                  ) : (
                                                    <p style={{ fontWeight: "bold" }}>CLOSED</p>
                                                  )
                                                ) : (
                                                  <p style={{ fontWeight: "bold" }}>CLOSED</p>
                                                )}
                                              </div>
                                            </div>
                                          </Fragment>
                                        ) : null}
                                      </Fragment>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {restaurantDetails?.cards?.length > 0 && (
                          <div className="fourthContainer">
                            <span className="paymentText">Payment method</span>
                            <span className="paymentTypeContainer">
                              {restaurantDetails.cards.map((data, ind) => {
                                return cardImages(data);
                              })}
                            </span>
                          </div>
                        )}

                        {/* <div className="col-3"></div> */}
                      </div>

                      <div className="row">
                        <div className="col-8 position-relative">
                          <div id="desktop-home-location-search-box-container">
                            <FindIcon
                              style={{ marginLeft: "1rem", fill: "#555555" }}
                            />

                            <div id="merchant-homePage-search">
                              <input
                                type="text"
                                ref={searchRef}
                                // <SearchIcon />
                                placeholder={"Search for dishes.."}
                                value={searchText}
                                onChange={(e) => {
                                  setSearchText(e.target.value);
                                  setFilterDropDown(true);
                                }}
                              />
                              <span className="desktop-location-search-bar-cancel">
                                {searchText?.length > 0 && (
                                  <CancelIcon
                                    onClick={() => {
                                      setSearchText("");
                                      // setIsSearching(false);
                                      // isContactlessDineInOrder &&
                                      //   dispatch(setMenuOption("Menu"));
                                    }}
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          {!isMobile &&
                          !restaurantDetailLoading &&
                          !restaurantMenuDetailLoading &&
                          restaurantMenuDetails &&
                          restaurantMenuDetails.length > 0 &&
                          totalDish === 0 &&
                          searchText?.length > 0 ? (
                            <div className="search-not-found">
                              <span>
                                Sorry We couldn't find any matches for
                              </span>
                              <span>{searchText ? searchText : ""}</span>
                              <div className="snf-list">
                                <span>
                                  <span className="snf-bullet"></span> Make sure
                                  the spelling is correct
                                </span>
                                <span>
                                  <span className="snf-bullet"></span>Use less
                                  keywords
                                </span>
                                <span>
                                  <span className="snf-bullet"></span>Try
                                  removing search
                                </span>
                              </div>
                            </div>
                          ) : null}
                          {filterDropDown && filterdDish?.length > 0 && (
                            <div className="filterd-dish-menu-container">
                              {displayDish.map((item) => {
                                return (
                                  <div
                                    className="filterd-dish-menu"
                                    key={item?.itemId}
                                    onClick={() => {
                                      setSearchText(item?.itemName);
                                      setFilterDropDown(false);
                                    }}
                                  >
                                    {item?.itemName}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-1"></div> */}
                  </div>
                </div>
                {/* yet to be implemented  */}
                {/* <div className="col-6">
                  <span>Images</span>
                </div> */}
              </div>
            </div>
            {(isServiceable || isShowPopup) && (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  width: "100%",
                  height: 50,
                  background: "#ffc3c3",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div>
                  {isServiceable ? <span style={{ color: "red", fontWeight: "500" }}>Online ordering is now closed and we are no longer accepting orders.</span> : 
                  isShowPopup ? <span style={{ color: "red", fontWeight: "500" }} id="wScheduler-status-msg" dangerouslySetInnerHTML={{ __html: formattedMessage }} /> : null}
                </div>
              </div>
            )}
            <br />
            <div className="row menu-body">
              <div className="col-6">
                <RestaurantHome
                  menuType={selectedMenuType}
                  searchText={searchText}
                  dishData={dishData}
                />
                {/* <span>Images</span> */}
              </div>

              {(isDeliveryOrder || isPickupOrder) && (
                <div className="desktop-col-3">
                  <div id="cart-item-details">
                    {restaurantDetails.open === 1 && (
                      <span className="header">
                        <span>Items in your cart</span>
                      </span>
                    )}
                    {orderItems.length > 0 && orderApiTotals.length > 0 && (
                      <span className="item-count">
                        {orderItems.length} items
                      </span>
                    )}
                    {/* <div className="cart-item-detail-container"> */}
                    {/* <br /> */}
                    {orderItems.length > 0 && orderApiTotals.length > 0 ? (
                      <>
                        <div className="desktop-home-cart-item-container">
                          {/* <p className="offerText">{"Offers"}</p> */}
                          {orderItems
                            .filter(
                              (cartItem: CartItem) =>
                                Number(cartItem.quantity) > 0
                            )
                            .map((cartItem: CartItem, index: number) => {
                              return (
                                <CartItemCard
                                  cartItem={cartItem}
                                  index={index}
                                  key={index}
                                  setCustomisationItemId={
                                    setCustomisationItemId
                                  }
                                  setOpenCustomisation={setOpenCustomisation}
                                />
                              );
                            })}
                          {/* <div id="desktop-bill-details-container">
                            <div className="desktop-bill-detail-head">
                              <div className="desktop-coupons">
                                <span>Coupons</span>
                              </div>
                              <span
                                className="desktop-viewCoupon-text"
                                onClick={() => setOfferPickerOpen(true)}
                              >
                                {selectedOffer ? "Change" : "View Coupons"}
                              </span>
                            </div>
                            <div className="desktop-viewCoupon-container">
                              <span className="desktop-selectCoupon-text">
                                {selectedOffer ? (
                                  selectedOffer?.offerCode
                                ) : (
                                  <span className="desktop-title-coupon-container">
                                    <Coupon /> &nbsp; Select a Coupon Code
                                  </span>
                                )}
                              </span>
                            </div>
                          </div> */}

                          {orderApiTotals && orderApiTotals.length > 0 ? (
                            <div id="desktop-bill-details-container">
                              <div className="desktop-bill-detail-head">
                                <div className="desktop-bill">
                                  <span>Bill Details</span>
                                </div>
                              </div>
                              <Fragment>
                                {orderApiTotals.map((item, index) => {
                                  return item.code == "5" ||
                                    item.code == "5.0" ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span className="desktop-totalAmount-text">
                                        {item.title}{" "}
                                      </span>
                                      <span className="desktop-totalAmount-text">
                                        <PriceText
                                          size="big"
                                          price={item.value || "0.00"}
                                        />
                                      </span>
                                    </div>
                                  ) : (item.code == "6" ||
                                      item.code == "6.0") &&
                                    parseFloat(item.value) > 0 ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>{item.title}</span>
                                      <div
                                        style={{
                                          color: "#FF5554",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        -{" "}
                                        <PriceText
                                          price={item.value || "0.00"}
                                        />
                                      </div>
                                    </div>
                                  ) : item.code == "3" || item.code == "3.0" ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>
                                        {item.title} &nbsp;&nbsp;
                                        {parseFloat(item.value) > 0 && (
                                          <span
                                            className="desktop-highlight-bill-text-placeOrder"
                                            onClick={() => {
                                              setIsTipModalVisible(true);
                                            }}
                                          >
                                            Change {item.title}
                                          </span>
                                        )}
                                      </span>

                                      {parseFloat(item.value) == 0 ? (
                                        <span
                                          className="desktop-highlight-bill-text-placeOrder"
                                          onClick={() =>
                                            setIsTipModalVisible(true)
                                          }
                                        >
                                          Add {item.title}
                                        </span>
                                      ) : (
                                        <span className="desktop-tip-value">
                                          <PriceText
                                          size="big"
                                            price={Number(item.value)}
                                          />
                                        </span>
                                      )}
                                    </div>
                                  ) : (item.code == "8" ||
                                      item.code == "8.0") &&
                                    parseFloat(item.value) > 0 ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>{item.title}</span>
                                      <PriceText price={item.value || "0.00"} />
                                    </div>
                                  ) : (item.code == "4" ||
                                      item.code == "4.0") &&
                                    parseFloat(item.value) > 0 ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>{item.title}</span>
                                      <PriceText price={item.value || "0.00"} />
                                    </div>
                                  ) : (item.code == "6" ||
                                      item.code == "6.0") &&
                                    parseFloat(item.value) > 0 ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>{item.title}</span>
                                      <PriceText price={item.value || "0.00"} />
                                    </div>
                                  ) : (item.code == "7" ||
                                      item.code == "7.0") &&
                                    parseFloat(item.value) > 0 ? (
                                    <div
                                      key={index}
                                      className="desktop-bill-detail"
                                    >
                                      <span>{item.title}</span>
                                      <PriceText price={item.value || "0.00"} />
                                    </div>
                                  ) : (item.code == "1" ||
                                    item.code == "1.0") &&
                                  parseFloat(item.value) > 0 ? (
                                  <div
                                    key={index}
                                    className="desktop-bill-detail"
                                  >
                                    <span>{item.title}</span>
                                    <PriceText price={item.value || "0.00"} />
                                  </div>
                                ) : (
                                    !(item.code == "4" || item.code == "4.0") &&
                                    !(item.code == "8" || item.code == "8.0") &&
                                    !(item.code == "7" || item.code == "7.0") &&
                                    !(
                                      item.code == "6" || item.code == "6.0"
                                    ) && (
                                      <div
                                        key={index}
                                        className="desktop-bill-detail"
                                      >
                                        <span>{item.title}</span>
                                        <PriceText
                                          price={item.value || "0.00"}
                                        />
                                      </div>
                                    )
                                  );
                                })}
                                {restaurantDetails?.isSurchargeEnabled && (
                                  <div className="surgeChargeTxt">
                                    Depending on the card used, a surcharge of
                                    up to 3% may apply.
                                  </div>
                                )}
                              </Fragment>
                            </div>
                          ) : null}

                          {/* <div className="desktop-bill-detail">
                                <span>{getTotalByCode(orderApiTotals, '1')?.title}</span>
                                <PriceText price={Number(getTotalByCode(orderApiTotals, '1')?.value) || '0.00'}/>
                              </div> */}

                          {/* Taxes and Charges */}
                          {/* <div className="desktop-bill-detail" onClick={() =>setShowExtraCharges(!showExtraCharges)}  >
                                <span>
                                  <span className="tax-a-charges" style={{ marginRight: "0.625rem" }} > Taxes & Charges </span>
                                  <ArrowIcon className={ showExtraCharges  ? "desktop-open-icon desktop-open-icon-selected"  : "desktop-open-icon" } />
                                </span>
                                <PriceText  price={Number(totalTaxAndCharges).toFixed(2)} isBill={true} />
                              </div> */}

                          {/* Extra Charges */}
                          {/* {showExtraCharges && (
                                <div className="desktop-extra-charges">
                                  <div className="desktop-bill-detail">
                                    <span>{getTotalByCode(orderApiTotals, '2')?.title}</span>
                                    <PriceText price={getTotalByCode(orderApiTotals, '2')?.value||'0.00'}  isBill={true} />
                                  </div>

                                  <Fragment>
                                    {(isDeliveryOrder || restaurantCountry != "US") && (
                                      <div className="desktop-bill-detail">
                                        <span> {isDeliveryOrder ? "Delivery Charge" : restaurantCountry != "US" && "Packaging Charge"} </span>
                                        {isDeliveryOrder ? (
                                          <PriceText price={Number(packagingCharge ).toFixed(2)}  isBill={true} />
                                        ) : (
                                          restaurantCountry != "US" && ( <PriceText price={Number( packagingCharge ).toFixed(2)} isBill={true} />)
                                        )}
                                      </div>
                                    )}
                                    {restaurantCountry == "US" && (
                                      <div className="desktop-bill-detail">
                                        <span>{getTotalByCode(orderApiTotals, '8')?.title}</span>
                                        <PriceText price={getTotalByCode(orderApiTotals, '8')?.value||0} isBill={true} />
                                      </div>
                                    )}
                                  </Fragment>
                                </div>
                              )}

                              <div className="desktop-bill-detail">
                                <span>{getTotalByCode(orderApiTotals, '7')?.title}</span>
                                <PriceText price={getTotalByCode(orderApiTotals, '7')?.value||0} />
                              </div> */}

                          {/* Tip */}
                          {/* {(tipDialogOpenned ||
                                (menuLocationState &&
                                  menuLocationState.backFromPlaceOrder) ||
                                tipAmount > 0) && (
                                <div className="desktop-bill-detail">
                                  <span>
                                  {getTotalByCode(orderApiTotals, '3')?.title} &nbsp;&nbsp;
                                    {getTotalByCode(orderApiTotals, '3')?.value || 0 > 0 && (
                                      <span className="desktop-highlight-bill-text-placeOrder"  onClick={() => {  setIsTipModalVisible(true); }} >
                                        Change tip
                                      </span>
                                    )}
                                  </span>

                                  {(getTotalByCode(orderApiTotals, '3')?.value ||0) == 0 ? (
                                    <span className="desktop-highlight-bill-text-placeOrder" onClick={() => setIsTipModalVisible(true)} >
                                      Add Tip
                                    </span>
                                  ) : (
                                    <span className="desktop-tip-value">
                                      <PriceText price={getTotalByCode(orderApiTotals, '3')?.value||0} />
                                    </span>
                                  )}
                                </div>
                              )}

                              {discountAmount > 0 && (
                                <div className="desktop-bill-detail">
                                  <span>{getTotalByCode(orderApiTotals, '6')?.title}</span>
                                  <div style={{ color: "#FF5554", display: "flex", alignItems: "center", }} >
                                    - <PriceText price={getTotalByCode(orderApiTotals, '6')?.value ||'0.00'} />
                                  </div>
                                </div>
                              )} */}

                          {/* Total */}
                          {/* <div className="desktop-bill-detail">
                                <span className="desktop-totalAmount-text"> {getTotalByCode(orderApiTotals, '5')?.title} </span>
                                <span className="desktop-totalAmount-text">
                                  <PriceText size="big" price={getTotalByCode(orderApiTotals, '5')?.value||'0.00'} />
                                </span>
                              </div> */}
                        </div>
                        <>
                          {minOrderAmount &&
                          minOrderAmount.minOrderAmount > 0 &&
                          minOrderAmount &&
                          totalItemsubTotal < minOrderAmount.minOrderAmount ? (
                            <span className="minimun-value-text">
                              <span> Minimum item value must be </span>
                              &nbsp; &nbsp;
                              <span className="price-text">
                                {/* <INRIcon /> &nbsp;
                        {minOrderAmount.minOrderAmount} */}
                                <PriceText
                                  price={
                                    minOrderAmount &&
                                    minOrderAmount.minOrderAmount
                                  }
                                />
                              </span>
                            </span>
                          ) : null}
                          {/* (
                            availWalletAmount &&
                            totalOrderPrice <= 0 && (
                              <span className="minimun-value-text">
                                <span>
                                  {" "}
                                  Minimum order value should be greater than{" "}
                                </span>
                                &nbsp; &nbsp;
                                <span className="price-text">
                                  <PriceText price={walletAmount} />
                                </span>
                              </span>
                            )
                          )} */}
                        </>
                        <>
                          <div className="promotional-msg-container">
                            <input
                              type="checkbox"
                              className="promotional-msg-checkbox"
                              checked={acmeConsent}
                              // value={}
                              onChange={(e) => {
                                setACMEConsent(!acmeConsent);
                              }}
                            />
                            <span className="promotional-msg-text">
                              By checking this box, you agree to receive SMS messages from{" "}
                              {restaurantDetails.branchName}. Message frequency varies. Message & data rates may apply. 
                              You can reply STOP to unsubscribe at any time. Click here to 
                             <a href="/Support/policy/notices" target="_blank" rel="noopener noreferrer"> view</a> Privacy Policy.
                            </span>
                          </div>
                        </>
                        <button
                          className={
                            acmeConsent
                              ? "submitButton"
                              : "submitButtonDisabled"
                          }
                          disabled={
                            (minOrderAmount?.minOrderAmount > 0 &&
                              totalItemsubTotal <
                                minOrderAmount.minOrderAmount) ||
                            !acmeConsent ||
                            totalsApiLoading
                          }
                          // style={
                          //   (minOrderAmount?.minOrderAmount > 0 &&
                          //     totalItemsubTotal < minOrderAmount.minOrderAmount )||
                          //     !acmeConsent
                          //     ? { background: "#787878" }
                          //     : {}
                          // }
                          // onClick={() =>
                          //   history.push(
                          //     getPlaceOrderDesktopURL(merchantType, merchantSlug)
                          //   )
                          // }
                          onClick={() => {
                            if (acmeConsent) {
                              if (isEventOrders && !isEventDate) {
                                setIsEventDatePickerVisible(true);
                              } else if (isAppliedTip) {
                                throttledOnSubmit();
                              } else if (acmeConsent) {
                                setIsTipModalVisible(true);
                                setTipDialogOpenned(true);
                              }
                            }
                          }}
                        >
                          {totalsApiLoading ? (
                            <div className="loaderDesktop"></div>
                          ) : (
                            <div>
                              <span className="submitText">Proceed</span>
                              <RightArrowFilled
                                style={{ marginLeft: "12px" }}
                              />
                            </div>
                          )}
                        </button>
                        {<span className="promotional-msg-text">
                             <br/>You can reply STOP to unsubscribe at any time. Message frequency varies. Message & data rates may apply.&nbsp;<a href="/Support/policy/notices" target="_blank" rel="noopener noreferrer">Click here </a> to view Privacy Policy.
                          </span>}
                      </>
                    ) : (
                      <>
                        {restaurantDetails.open === 0 ? (
                          <div className="desktop-closeIcon-container">
                            <CloseIcon />
                          </div>
                        ) : (
                          <span style={{ textAlign: "center" }}>
                            Cart is empty !
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Fragment>
      </div>
      <div className="merchant_footer">
        <DesktopFooter />
      </div>
    </>
  );
}
export default MerchantInfoDesktop;
